import { render, staticRenderFns } from "./ProjectAssignmentMenu.vue?vue&type=template&id=33edb660&scoped=true"
import script from "./ProjectAssignmentMenu.vue?vue&type=script&lang=js"
export * from "./ProjectAssignmentMenu.vue?vue&type=script&lang=js"
import style0 from "./ProjectAssignmentMenu.vue?vue&type=style&index=0&id=33edb660&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33edb660",
  null
  
)

export default component.exports